import { render, staticRenderFns } from "./AddNewSelector.vue?vue&type=template&id=4f22c6d2&scoped=true"
import script from "./AddNewSelector.vue?vue&type=script&lang=js"
export * from "./AddNewSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22c6d2",
  null
  
)

export default component.exports